import React, { Component } from 'react';

type Props = {
    label: string;
    onClick: () => void
    type?: "primary" | "secondary" | undefined;
    disabled?: boolean;
    id?: string;
};

export class FstyrButton extends Component<Props> {

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    getType = (): string => { return this.props.type ?? "primary" }

    render() {
        return (
            <div
                className={`button button-${this.getType()}${this.props.disabled ? " disabled" : ""} noselect`}
                onClick={this.props.disabled ? () => { } : this.props.onClick}
                id={this.props.id}
            >
                {this.props.label}
            </div>
        );
    }
}